import type { SubjectCode, SubjectMetadata } from '~/models/Subject'
import type { GradeCode } from '~/models/Grade'
import {
  combinedGrades,
  GRADE_ADULT,
  GRADE_PREP,
  gradesVgs,
  higherGrades,
  lowerGrades,
} from '~/utils/gradeSorter'

const subjectMetadata: SubjectMetadata[] = [
  { subject: 'ENG', grades: combinedGrades },
  { subject: 'FSP', grades: higherGrades },
  { subject: 'KRO', grades: combinedGrades },
  { subject: 'MAT', grades: combinedGrades.concat([GRADE_PREP]) },
  { subject: 'NAT', grades: combinedGrades },
  { subject: 'NOR', grades: combinedGrades.concat([GRADE_ADULT]) },
  { subject: 'SAF', grades: lowerGrades },
  { subject: 'FYS', grades: gradesVgs.concat([GRADE_PREP]) },
  { subject: 'GEO', grades: gradesVgs },
  { subject: 'GFG', grades: gradesVgs },
  { subject: 'HEL', grades: gradesVgs },
  { subject: 'HIS', grades: gradesVgs },
  { subject: 'KJE', grades: gradesVgs },
  { subject: 'MED', grades: gradesVgs },
  { subject: 'POL', grades: gradesVgs },
  { subject: 'PSY', grades: gradesVgs },
  { subject: 'REL', grades: gradesVgs },
  { subject: 'KRL', grades: lowerGrades },
  { subject: 'TVE', grades: combinedGrades },
  { subject: 'FLE', grades: combinedGrades },
  { subject: 'INF', grades: gradesVgs },
  { subject: 'SPA', grades: higherGrades },
  { subject: 'TYS', grades: higherGrades },
  { subject: 'FRA', grades: higherGrades },
  { subject: 'KHV', grades: lowerGrades },
  { subject: 'MUS', grades: lowerGrades },
  { subject: 'MHE', grades: lowerGrades },
  { subject: 'SAK', grades: gradesVgs },
  { subject: 'SOK', grades: gradesVgs },
  { subject: 'SAG', grades: gradesVgs },
  { subject: 'SOS', grades: gradesVgs },
  { subject: 'POM', grades: gradesVgs },
]

export const findSubjectsByGrade = (grade: GradeCode): SubjectCode[] => {
  return subjectMetadata
    .filter(metadata => metadata.grades.includes(grade))
    .map(metadata => metadata.subject)
}

export const findGradesBySubject = (subject: SubjectCode): GradeCode[] => {
  return subjectMetadata
    .find(metadata => metadata.subject === subject)
    ?.grades || []
}
